import { ICrossPart } from '../models/CrossPartDetails';
import { IProductDetails } from '../models/ProductDetails';
import { ISiteWrapper } from '../models/SiteWrapper';
import { IMediaLinkDetail } from '../models/MediaLinkDetail';
import { IShortUrl } from '../models/IShortUrl';
import { IProductDetailById, IProductVariation } from '../models/ProductDetailById';
import { UserData } from '../models/UserData';
import { ISearchQueryRequest } from '../models/ISearchQueryRequest';
import { HOST_NAME_LOCAL, USER_DATA_LOGGED_IN } from '../constants';
import { ISiteLangValidation } from '../models/SiteLangValidation';
import { isLocalEnvironment } from '../ultils';

export const getCrossPartDetails = async (
    mfgPartNumber: string,
    vendorID: number,
    lang?: string,
    site?: string
): Promise<ICrossPart> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/cross-part-detail`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                manufacturerPartNumber: mfgPartNumber,
                vendorId: vendorID,
                languageIsoCode: lang,
                siteIsoCode: site
            })
        }
    );
    return response.json();
};

export const getNonDKPartCross = async (
    mfgPartNumber: string,
    lang?: string,
    site?: string
): Promise<ICrossPart> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/non-dk-cross-detail`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                manufacturerPartNumber: mfgPartNumber,
                lang: lang,
                site: site
            })
        }
    );
    return response.json();
};

// New GetSiteWrapper for New Header/footer on Production
export const getSiteWrapper = async (): Promise<ISiteWrapper> => {
    const searchStr = '.digikey.';
    const tld = window.location.hostname.substring(
        window.location.hostname.indexOf(searchStr) + searchStr.length
    );
    const hostname = window.location.hostname;
    const langTemp = window.location.pathname.split('/')[1];
    let lang = '';

    if (langTemp.length !== 2) lang = 'en';
    else lang = langTemp;
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/getSiteWrapper`,
        {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                tldToGetSite: tld,
                language: lang,
                hostName: hostname
            })
        }
    );
    return response.json();
};

export const getProductDetails = async (
    productId: string,
    isLoggedIn: boolean,
    lang?: string,
    site?: string,
    currency?: string,
    productVariations?: IProductVariation[],
    manufacturerId? : number
): Promise<IProductDetails> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/product-and-pin-detail`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                manufacturerPartNumber: productId,
                isLogged: isLoggedIn,
                lang: lang,
                site: site,
                currency: currency,
                vendorId: manufacturerId,
                productVariations: productVariations
            })
        }
    );
    return response.json();
};

// ! for improve table starts
export const getProductDetailByIds = async (
    listCrossPartId: number[],
    manufacturerPartNumber: string,
    manufacturerId: number,
    lang?: string,
    site?: string,
    currency?:string
): Promise<IProductDetailById[]> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/product-and-pin-detail-by-ids`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                productIds: listCrossPartId,
                manufacturerPartNumber,
                vendorId: manufacturerId,
                lang: lang,
                site: site,
                currency: currency
            })
        }
    );
    return response.json();
};

export const getMediaLink = async (
    productIds: number[],
    lang?: string,
    site?: string
): Promise<IMediaLinkDetail[]> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/media-link`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                productIds: productIds,
                lang: lang,
                site: site
            })
        }
    );
    return response.json();
};

export const createShortUrl = async (url: string): Promise<IShortUrl> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/create-short-url`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                url,
                method: 'GET'
            })
        }
    );
    return response.json();
};

export const getUrlById = async (urlId: string): Promise<IShortUrl> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/url-by-id`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(urlId)
        }
    );
    return response.json();
};

//Get ProductDetailsByIds when not logging in
export const getProductDetailByIdsUnLogged = async (
    listCrossPartId: number[],
    sourceDetail: any,
    lang?: string,
    site?: string,
    currency?: string,
    manufacturerPartNumber?: string,
    manufacturerId?: number,
): Promise<IProductDetailById[]> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/product-and-pin-detail-by-ids-unlogged`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                productIds: listCrossPartId,
                paramsMapJson: sourceDetail,
                lang: lang,
                site: site,
                currency: currency,
                manufacturerPartNumber,
                vendorId: manufacturerId
            })
        }
    );
    return response.json();
};

//Get UserData
export const getUserData = async (): Promise<UserData> => {
    if (isLocalEnvironment()) {
        return USER_DATA_LOGGED_IN;
    } else {
        const response = await fetch(
            `/MyDigiKey/Home/GetCurrentUser`,
            // `https://digikeytest.digikey.com/MyDigiKey/Home/GetCurrentUser`,
            //user this link to get CurrentUser insead of Localhost5000 to avoid f5 https security error when develop, the default value of isUser is false(unlogged)

            {
                method: 'GET',
                headers: {
                    Accept: 'application/json, text/plain, text/html',
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }
        );
        return response.json();
    }
};

export const getBasePartNumberDetails = async (
    mfgPartId: number,
    baseProductId: number,
    lang?: string,
    site?: string,
    currency?:string,
): Promise<IProductDetails> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/base-part-number-detail`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                ManufacturerPartId: mfgPartId,
                BaseProductId: baseProductId,
                lang: lang,
                site: site,
                currency:currency
            })
        }
    );
    return response.json();
};

export const getBasePartNumberDetailsUnLogged = async (
    mfgPartId: number,
    baseProductId: number,
    sourceDetail: any,
    lang?: string,
    site?: string,
    currency?:string
): Promise<IProductDetails> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/base-part-number-detail-unlogged`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                ManufacturerPartId: mfgPartId,
                BaseProductId: baseProductId,
                paramsMapJson: sourceDetail,
                lang: lang,
                site: site,
                currency: currency
            })
        }
    );
    return response.json();
};

export const getQueryString = async (
    searchRequest: ISearchQueryRequest
): Promise<string> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    if (Object.keys(searchRequest).length === 0) {
        return 'N4XyA';
    } else {
        const response = await fetch(
            `${HOST_NAME}/en/cross-reference/api/internal/search-query-string`,
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, text/html',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify(searchRequest)
            }
        );
        return response.json();
    }
};

export const getSearchCount = async (
    searchRequest: ISearchQueryRequest
): Promise<string> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    if (Object.keys(searchRequest).length === 0) {
        return '';
    } else {
        const response = await fetch(
            `${HOST_NAME}/en/cross-reference/api/internal/search-count`,
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, text/html',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify(searchRequest)
            }
        );
        return response.json();
    }
};

export const getListInfo = async (customerId: number) => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/getListInfo`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                CustomerId: customerId
            })
        }
    );
    return response.json();
};

export const createNewList = async (customerId: number, listName: string) => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/create-new-list`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                CustomerId: customerId,
                ListName: listName
            })
        }
    );
    return response.json();
};

export const addPartToList = async (
    customerId: number,
    listId: string,
    bodyRequest: { partId: number }[]
) => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/add-part-to-list`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                CustomerId: customerId,
                ListId: listId,
                PartIds: bodyRequest
            })
        }
    );
    return response.json();
};

export const addProductsAlternateToList = async (
    customerId: number,
    listId: string,
    uniqueID: string, 
    bodyRequest: string[]
) => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/add-products-alternate-to-list`,
        {
            method: 'PUT',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                CustomerId: customerId,
                ListId: listId,
                UniqueID: uniqueID,
                PartNumber: bodyRequest
            })
        }
    );
    return response.text();
};

export const getListNameById = async (customerId: number, listId: string) => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/get-list-name-by-id`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                CustomerId: customerId,
                ListId: listId
            })
        }
    );
    return response.json();
};

const getSiteLangFromUrl = () => {
    let langSite = { tldFromUrl: '', langFromUrl: '' };
    const searchStr = '.digikey.';
    const tld = window.location.hostname.substring(
        window.location.hostname.indexOf(searchStr) + searchStr.length
    );
    const langTemp = window.location.pathname.split('/')[1];
    let lang = '';

    if (langTemp.length !== 2) lang = 'en';
    else lang = langTemp;
    langSite.tldFromUrl = tld;
    langSite.langFromUrl = lang;
    return langSite;
};

// Check if the pair of site/lang is valid
export const getValidateSiteLang = async (): Promise<ISiteLangValidation> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const siteLangFromUrL = getSiteLangFromUrl();
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/getValidateSiteLang`,
        {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                tldToGetSite: siteLangFromUrL.tldFromUrl,
                language: siteLangFromUrL.langFromUrl
            })
        }
    );
    return response.json();
};

export const getCompareQueryString = async (
    productIds: number[],
    returnUrl: string
): Promise<string> => {
    const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
    const response = await fetch(
        `${HOST_NAME}/en/cross-reference/api/internal/compare-query-string`,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, text/html',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                productIds,
                returnUrl
            })
        }
    );
    return response.json();
};

// Api get exclude tariff flag
export const getTariffFunctionFlag = async (
): Promise<any> => {
  const HOST_NAME = isLocalEnvironment() ? HOST_NAME_LOCAL : '';
  const response = await fetch(
    `${HOST_NAME}/en/cross-reference/api/internal/get-tariff-function-flag`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json, text/plain, text/html',
        'Content-Type': 'application/json;charset=UTF-8'
      },
    }
  );
  return response.json();
};